module.exports = __webpack_public_path__ + "img/landing_box53.680cd74c.jpg";